import {useQuery, UseQueryResult} from '@tanstack/react-query';
import baseUrl from '../baseUrl';
import {useCreateAuthenticatedFetch} from '../useCreateAuthenticatedFetch';
import {handleResponse} from '../handleResponse';
import {WorkspaceContactGroup} from '../../lib/workspaceContacts';

export type {
    WorkspaceContact,
    WorkspaceContactGroup
} from '../../lib/workspaceContacts';
export {cappedListNote} from '../../lib/workspaceContacts';

/**
 * Who manages the workspace, by customer role (support contact first). Any
 * signed-in user may ask: in a large organisation it can be hard to know who
 * grants access or helps. Fetched only while the panel is open.
 */
export const useWorkspaceContacts = (
    enabled: boolean
): UseQueryResult<WorkspaceContactGroup[], Error> => {
    const authenticatedFetch = useCreateAuthenticatedFetch();

    return useQuery({
        queryKey: ['resource-allocation', 'workspace-contacts'],
        queryFn: async (): Promise<WorkspaceContactGroup[]> =>
            handleResponse(
                await authenticatedFetch(
                    `${baseUrl}/api/resource-allocation/workspace-contacts`
                )
            ),
        enabled
    });
};

export default useWorkspaceContacts;
